/**
 * Constants
 */
export const CHANGE_CITY = 'app/CHANGE_CITY';
export const PLAY = 'app/PLAY';
export const PAUSE = 'app/PAUSE';


/**
 * Action Creators
 */
export function changeCity(name) {
    return {
        type: CHANGE_CITY,
        value: name
    };
}

export function playSound() {
    return {
        type: PLAY
    };
}

export function pauseSound() {
    return {
        type: PAUSE
    };
}


/**
 * Reducer
 */
const cities = {
    padang: {
        title: 'Padang',
        image: 'padang',
        sound: 'padang'
    },
    bali: {
        title: 'Bali',
        image: 'bali',
        sound: 'bali'
    },
    bandung: {
        title: 'Bandung',
        image: 'bandung',
        sound: 'bandung'
    },
    jogja: {
        title: 'Jogja',
        image: 'jogja',
        sound: 'jogja'
    }
};

const initialState = {
    selectedCity: undefined,
    cities: cities,
    isPlaying: false
};

export default function app(state = initialState, action) {
    switch (action.type) {
        case CHANGE_CITY:
            return {
                ...state,
                selectedCity: action.value
            };
        
        case PLAY:
            return {
                ...state,
                isPlaying: true
            };
        
        case PAUSE:
            return {
                ...state,
                isPlaying: false
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/app.js